import { render, staticRenderFns } from "./bullWiseSemenDespatchNote.vue?vue&type=template&id=0d9b5650&scoped=true&"
import script from "./bullWiseSemenDespatchNote.vue?vue&type=script&lang=js&"
export * from "./bullWiseSemenDespatchNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b5650",
  null
  
)

export default component.exports